export const currencyFormatter = (
  amount: number | string = 0,
  format: string = "IN",
  Fraction = 2
) => {
  const currencyMap: Record<string, { locale: string; currency: string }> = {
    IN: { locale: "en-IN", currency: "INR" },
    US: { locale: "en-US", currency: "USD" },
    EU: { locale: "en-GB", currency: "EUR" },
    UK: { locale: "en-GB", currency: "GBP" },
    JP: { locale: "ja-JP", currency: "JPY" },
  };

  const { locale, currency } = currencyMap[format] || currencyMap["IN"];

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: Fraction,
  }).format(Number(amount));
};

// e.g. { Size: "S", Color: "Red" } -> "Size: S, Color: Red"
export const formatVariantLabel = (
  optionValues?: Record<string, string> | null
) => {
  if (!optionValues) return "";
  return Object.entries(optionValues)
    .map(([name, value]) => `${name}: ${value}`)
    .join(", ");
};

export const truncateText = (text: string = "", maxLength: number) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
};

export const formatCreatedBy = (
  createdBy?: {
    firstName?: string;
    lastName?: string;
    role?: { name?: string } | string;
    name?: string;
  } | string
) => {
  if (!createdBy || typeof createdBy === "string") return "-";
  const firstName = createdBy.firstName || "";
  const lastName = createdBy.lastName || "";
  const displayName = `${firstName} ${lastName}`.trim() || createdBy.name || "";
  const roleName =
    typeof createdBy.role === "string"
      ? createdBy.role
      : createdBy.role?.name;

  if (!displayName && !roleName) return "-";
  return (
    <div>
      <div>{displayName || "User"}</div>
      {roleName && <div className="text-xs text-gray-500">({roleName})</div>}
    </div>
  );
};
